import moment from 'moment';
import { createContext } from 'react';

/**
 * Даты по умолчанию, учитываемые в режиме без дат
 * @type {React.Context<{dateStartDefault: moment.Moment, dateEndDefault: moment.Moment}|null>}
 */
export const DefaultDatesRangeContext = createContext(null);
